module.exports = __webpack_public_path__ + "76612cd1d5679a984e11ed11a278ae79.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/united_kingdom_icon.png
// module id = 1223
// module chunks = 0